import Cookies from "js-cookie";
import service from "../../Services/apiheader";

const xevmpdPrefix = "xevmpd";



export const postProcess = (
  body: API.PostProcessBody
): Promise<API.DataResponse<boolean>> =>
  service.post(`${xevmpdPrefix}/process/post/association`, body, {
    headers: {
      "x-tenant-id": Cookies.get("USER_TENANT_ID"),
    },
  });

export const initializeProcess = (
  body: API.PostProcessBody
): Promise<API.DataResponse<boolean>> =>
  service.post(`${xevmpdPrefix}/process/post/initialize`, body, {
    headers: {
      "x-tenant-id": Cookies.get("USER_TENANT_ID"),
    },
  });

export const terminateProcess = async (
  id: string,
  updatedBy: string,
  comments: string,
  userId: string
): Promise<API.DataResponse<boolean>> => {
  const response = await service.post<API.DataResponse<boolean>>(
    `${xevmpdPrefix}/process/terminate`,
    {
      businessId: id,
      updatedBy,
      comments,
      userId,
    },
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID"),
      },
    }
  );

  return response.data;
};


export const getTaskResultProperty = (
  id: string,
  userId: String
): Promise<API.DataResponse<API.TaskResultProperty>> =>
  service.get(
    `${xevmpdPrefix}/process/task-result-property?xevmpdId=${id}&userId=${userId}`,
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID"),
      },
    }
  );  //   

export const getPrecessRelatedInfo = (
  id: string,
  userId: string
): Promise<API.DataResponse<API.PrecessRelatedInfo>> =>
  service.get(`${xevmpdPrefix}/process/pmRelated?xevmpdId=${id}&userId=${userId}`, {
    headers: {
      "x-tenant-id": Cookies.get("USER_TENANT_ID"),
    },
  });  // initialise

export const advanceNextStep = (
  xevmpdId: string,
  userId: string,
  updatedBy: string,
  taskResult: string,
  comments: string
): Promise<API.DataResponse<boolean>> =>
  service.post(`${xevmpdPrefix}/process/nextStep`,
    {
      xevmpdId,
      userId,
      updatedBy,
      taskResult,
      comments,
    },
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID"),
      },
    }
  );

  export const resetProcess = (
    businessId: string,
    updatedBy: string,
    userId:string,
    comments: string
  ): Promise<API.DataResponse<boolean>> =>
    service.post(`${xevmpdPrefix}/process/reset`, { businessId,updatedBy,userId,comments },
    {
      headers: {
        "x-tenant-id": Cookies.get("USER_TENANT_ID"),
      },
    }
  );


  export const postComments = (
  params: API.CommentBody
): Promise<API.DataResponse<string>> =>
  service.post(`/comment/comments`, params);